/**
 * Notification module
 */
import controller from './controller';

/**
 * @property {object}   exports             - Our module exports
 * @property {string}   exports.namespace   - Module namespace
 * @property {function} exports.initialize  - Module initializer
 */
export default {
	namespace: 'notification',
	initialize: () => controller.initialize(),
};
